function StatsCard({ title, value, color, change }) {

  const bgColor = {
    blue: "bg-blue-100",
    red: "bg-red-100",
    green: "bg-green-100",
    purple: "bg-purple-100"
  };

  const icon = {
    blue: "💰",
    red: "💸",
    green: "📈",
    purple: "📁"
  };

  const isPositive = change >= 0;

  return (
    <div className="bg-white p-5 rounded-xl shadow-sm border flex justify-between items-center">

      {/* LEFT */}
      <div>
        <h3 className="text-sm text-gray-500">{title}</h3>

        <p className="text-xl font-bold mt-2">{value}</p>

        {change !== undefined && (
          <p className={`text-xs mt-1 ${isPositive ? "text-green-600" : "text-red-600"}`}>
            {isPositive ? "↑" : "↓"} {Math.abs(change)}% from last month
          </p>
        )}
      </div>

      {/* RIGHT ICON (NO LIBRARY) */}
      <div className={`${bgColor[color]} p-3 rounded-full text-lg`}>
        {icon[color]}
      </div>

    </div>
  );
}

export default StatsCard;